import { Row, Col, Button, Tooltip } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import DataTable from "../../../../common/DataTable";
import { INJURY_HEADERS, INJURY_LOG_HEADERS } from "../actions/constant";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchInjuryDetails,
  FetchNatureOfInjury,
} from "../../../../services/InjuryAPI";
import moment from "moment";
import Loader from "../../../../common/Loader";

interface InjuryTableProps {
  caseInfoID: any;
  caseSubjectID: any;
  onRowSelect: any;

  subTab: any;
  activeKey: any;
  // onTabChange: () => void;
}

const InjuryDetailsTable: React.FC<InjuryTableProps> = ({
  caseSubjectID,
  onRowSelect,

  subTab,
  activeKey,
  // onTabChange,
}) => {
  const [injuryData, setInjuryData] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [natureOfInjuryOptions, setNatureOfInjuryOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      const natureOptions = await FetchNatureOfInjury();
      setNatureOfInjuryOptions(natureOptions);
      setInjuryData([]); // clear before loading
      const response = await FetchInjuryDetails(caseSubjectID);

      if (response?.isSuccess && response.result.length > 0) {
        const injuryDetails = response.result.map((item: any) => {
          const natureIds = item.natureOfInjuryID?.split(",") || [];

          const matchedNatureLabels = natureOptions
            .filter((opt) => natureIds.includes(String(opt.value)))
            .map((opt) => opt.label)
            .join(", ");

          let incidentDisplayDate = "-";

          if (item.injuryTypeDesc === "Specific") {
            incidentDisplayDate = item.dateOfIncident
              ? moment(item.dateOfIncident).format("MM/DD/YYYY")
              : "-";
          } else if (item.injuryTypeDesc === "Continious Trauma (CT)") {
            const start = item.doictStartDate
              ? moment(item.doictStartDate).format("MM/DD/YYYY")
              : "-";
            const end = item.doictEndDate
              ? moment(item.doictEndDate).format("MM/DD/YYYY")
              : "-";
            incidentDisplayDate = start && end ? `${start} - ${end}` : "-";
          }

          return {
            rawItem: item,
            caseSubjectInjuryID: item.caseSubjectInjuryID || "",
            injuryTypeId: item.injuryTypeID ?? "",
            injuryTypeName: item.injuryTypeDesc || "",
            formattedDate: incidentDisplayDate, // <-- updated logic
            isPrimaryInjury: item.isPrimaryInjury == 1 ? "Yes" : "No",
            claimNumber: item.claimNumber || "-",
            natureOfInjuryId: item.natureOfInjuryID || "",
            insuranceCarrierName: item.insuranceCarrierName || "",
            doctorName: item.doctorName || "",
            insuranceCarrierId: item.insuranceCarrierId || "",
            natureOfInjuryName: matchedNatureLabels || "-",
            severityOfInjuryId: item.severityOfInjuryID ?? "",
            severityOfInjuryName: item.severityOfInjuryDesc || "-",
            injuryDetails: item.injuryDetails || "-",
            bodyPartsAffected: item.bodyPartsAffected || "-",
            additionalBodyPartsAffected:
              item.additionalBodyPartsAffected || "-",
            additionalComments: item.additionalComments || "-",

            actions: { Edit: "Edit" },
          };
        });

        setInjuryData(injuryDetails);
      } else {
        setInjuryData([]);
      }
    } catch (error) {
      console.error("Error fetching injury or nature options:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAllData();
  }, [caseSubjectID, activeKey]); // <-- add refreshTrigger

  const handleRowAction = (row?: any, action?: string) => {
    if (action === "Edit" && row?.rawItem) {
      onRowSelect(row.rawItem); // Send full raw data
    }
  };
  return (
    <>
      <div className="d-flex justify-content-between align-items-center border-bottom pb-1 px-0 col mb-3">
        <h3 className="mr-2 me-auto">List</h3>
      </div>
      <Loader isLoading={loading} />
      <Row>
        <Col>
          <DataTable
            headers={INJURY_HEADERS}
            rows={injuryData}
            selectedRow={selectedRow}
            onAction={handleRowAction}
          />
        </Col>
      </Row>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default InjuryDetailsTable;
